import { type AuthSession } from './types';

type Listener = () => void;

const emptySession: AuthSession = {
  tokens: null,
  user: null
};

class AuthSessionStore {
  private snapshot: AuthSession = emptySession;
  private readonly listeners = new Set<Listener>();

  public subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  public getSnapshot(): AuthSession {
    return this.snapshot;
  }

  public setState(partial: Partial<AuthSession>): void {
    this.snapshot = { ...this.snapshot, ...partial };
    this.listeners.forEach(listener => listener());
  }

  public reset(): void {
    this.snapshot = emptySession;
    this.listeners.forEach(listener => listener());
  }
}

export const authSessionStore = new AuthSessionStore();
